import React from 'react';

import { Icon } from '@atom/mui';

import classes from './field.module.css';

export interface Props {
  icon?: string;
  iconColor?: string;
  label?: string;
  input: React.ReactNode;
}

const Field = ({ icon, iconColor, label, input }: Props) => (
  <div className={classes.field}>
    <div className={classes.fieldIcon}>
      {icon && <Icon color={iconColor}>{icon}</Icon>}
    </div>
    <div className={classes.fieldContent}>
      {label && <div className={classes.fieldTitle}>{label}</div>}
      <div className={classes.fieldComponent}>{input}</div>
    </div>
  </div>
);

export default Field;
